import type { NoiseFunction3D } from "simplex-noise";
import type { GameConfig } from "../config/GameConfig";
import { normalize } from "../core/math";
import type { Divider } from "../entities/Divider";

/**
 * Vórtice tangente à oval, sempre contra os ponteiros do relógio.
 * Vento e oceano só mudam a força; o sentido não inverte.
 */
export class OvalVortex {
  constructor(
    private readonly config: GameConfig,
    private readonly noise: NoiseFunction3D,
  ) {}

  sample(x: number, y: number, time: number, divider: Divider): { x: number; y: number } {
    const w = this.config.wind;
    const o = this.config.ocean;
    const hit = divider.closest(x, y);
    /** Ecrã com Y para baixo: (ny, −nx) = sentido anti-horário. */
    const tangent = normalize(hit.ny, -hit.nx);

    const nt = time * w.noiseSpeed;
    const ot = time * o.noiseSpeed;
    const windPulse = 0.5 + 0.5 * this.noise(x * w.noiseScale, y * w.noiseScale, nt);
    const oceanPulse =
      0.5 + 0.5 * this.noise(x * o.noiseScale + 11, y * o.noiseScale + 3, ot + 5);

    const windMag = w.strength * w.lateralBias * (0.45 + w.turbulence * windPulse);
    const oceanMag = o.strength * o.lateralBias * (0.45 + o.turbulence * oceanPulse);
    const mag = Math.max(0, windMag + oceanMag);
    const inward = w.strength * w.verticalBias * (0.35 + 0.3 * windPulse);

    return {
      x: tangent.x * mag - hit.nx * inward,
      y: tangent.y * mag - hit.ny * inward,
    };
  }
}
